import Swiper, { Pagination } from "swiper";

  const projectGreenSwiper = new Swiper(
    document.querySelector(".project-green"),
    {
      slidesPerView: 1,
      spaceBetween: 0,
      modules: [Pagination],
      pagination: {
        el: "[data-pagination]",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },
    }
  );

export default projectGreenSwiper;
